import(/* webpackMode: "eager", webpackExports: ["TestimonialsPageContent"] */ "/app/components/frontend/testimonials/testimonials-page-content.tsx");
